import { render, staticRenderFns } from "./SectorsSection.vue?vue&type=template&id=834bf4c0"
import script from "./SectorsSection.vue?vue&type=script&lang=js"
export * from "./SectorsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports